<template>
  <div class="rounded-xl border-[1px] border-slate-200 p-2">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
